import AlertIcon from '@/assets/icons/alert.svg?react';
import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';

type ErrorStateProps = {
  headingLevel?: 'h1' | 'h2';
  title?: string;
  message?: string;
  onRetry?: () => void;
};

export function ErrorState({
  headingLevel = 'h2',
  title = 'This page did not load',
  message = 'Macswarm could not be reached. Try again in a moment.',
  onRetry,
}: ErrorStateProps) {
  const Heading = headingLevel;
  return (
    <div role="alert" className="flex flex-col items-start gap-4.5">
      <BadgeIcon tone="bad">
        <AlertIcon className="size-5.5" />
      </BadgeIcon>
      <div className="flex flex-col gap-2">
        <Heading className="font-semibold text-title">{title}</Heading>
        <p className="text-muted">{message}</p>
      </div>
      {onRetry ? (
        <Button onClick={onRetry} variant="primary">
          Try again
        </Button>
      ) : null}
    </div>
  );
}
